export var version = "3.8.7";
//# sourceMappingURL=version.js.map